
// TODO: should polish
const NoMatch = (): JSX.Element => (
  <>404</>
);

export default NoMatch;
